import { z } from "zod";

export const NovosNegociosSchema = z.object({
    idNovosNegocios: z.number().int().optional(),
    nrNegocio: z.coerce.string().optional().nullable(),
    titulo: z.string().optional().nullable(),
    idCliente: z.number().int().optional().nullable(),
    idCentroCusto: z.number().int().optional().nullable(),
    nProposta: z.string().optional().nullable(),
    nEdital: z.string().optional().nullable(),

    possivelEscopo: z.boolean().optional().nullable(),
    viavelFinanc: z.boolean().optional().nullable(),
    possivelPrazos: z.boolean().optional().nullable(),
    possivelReqLegais: z.boolean().optional().nullable(),

    comentarios: z.string().optional().nullable(),
    situacaoProposta: z.coerce.number().int().optional().nullable().default(null), // 0: Em análise, 1: Participar, 2: Descartar
    statusParticipar: z.coerce.number().int().optional().nullable().default(null), // 0: Ganha, 1: Perdida, 2: Inabilitada, 3: Outros, 
    outros: z.string().optional().nullable(),
    observacao: z.string().optional().nullable(),
    dataCriacao: z.coerce.date().optional().nullable(),

    arquivo: z.instanceof(File).optional().nullable(),
    nomeArquivo: z.string().optional().nullable(),

    data: z.coerce.date().optional().nullable(),
    cidade: z.string().optional().nullable(),
    idFuncionario: z.number().int().optional().nullable(),
    telefone: z.string().optional().nullable(),

    //analisar
    dadosCliente: z.string().optional().nullable(),
    dataSituacao: z.coerce.date().optional().nullable(),

    limparArquivo: z.boolean().optional().nullable(),
});

export type NovosNegociosForm = z.infer<typeof NovosNegociosSchema>;

export const defaultNovosNegociosForm: Partial<NovosNegociosForm> = {
    idNovosNegocios: 0,
    nrNegocio: undefined,
    titulo: undefined,
    idCliente: undefined,
    idCentroCusto: undefined,
    nProposta: undefined,
    nEdital: undefined,
    possivelEscopo: undefined,
    viavelFinanc: undefined,
    possivelPrazos: undefined,
    possivelReqLegais: undefined,
    comentarios: undefined,
    situacaoProposta: null,
    statusParticipar: null,
    outros: undefined,
    observacao: undefined,
    dataCriacao: undefined,
    arquivo: undefined,
    nomeArquivo: undefined,
    data: undefined,
    cidade: undefined,
    idFuncionario: undefined,
    telefone: '',
    dadosCliente: undefined,
    dataSituacao: undefined,
    limparArquivo: false,
};
